export const type = 'form.label';
